var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(("h" + (_vm.attrs.level)),{tag:"component",attrs:{"id":_vm.getId}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }